import './MyCv.css';
import Image from './assets/images/rv.jpeg'
import { DocumentCard } from './components/DocumentCard/DocumentCard';
import { DataField } from './components/Label/DataField/DataField';
import { Label } from './components/Label/Label';

const MyCv = () => {
  return (
    <div className="MyCv">
      {/* bild */}
      <img id='img-persona' src={Image} alt={"Bild von Rosen Vasilev"} />

      {/* name */}
      <h1 className="name strong">Rosen Vasilev</h1>

      {/* details */}
      <div className='blockquote'>
        <div>
          <a href="mailto:rosen@vasilev.it">rosen@vasilev.it</a>
        </div>
        <div>
          <a href="https://www.linkedin.com/in/rosen-vasilev-82ba9726/" target="_blank">LinkedIn</a>
        </div>
        <div>
          <a href="https://rosenvasilev.de/aboutme" target="_blank">Website</a>
        </div>
      </div>

      {/* i am */}
      <DocumentCard
        label="Ich bin"
        body="Erfahrener Softwareentwickler mit Spezialisierung auf Backend-, Frontend- und Cloud-Technologien. Ich habe Leidenschaft für Automatisierung, DevOps und skalierbare Softwarearchitekturen. Analytisch, lösungsorientiert und teamfähig, mit einer ausgeprägten Hands-on-Mentalität." />

      {/* i search  */}
      <DocumentCard
        label="Ich suche"
        body="Eine spannende Herausforderung, in der ich meine Erfahrungen und Ideen einsetzen kann. Ein innovatives Umfeld, das Technisches mit Kreativem verbindet. Offene, agile Zusammenarbeit, bei der ich beruflich und persönlich weiterwachsen kann." />

      {/* tech skills */}
      <Label text='Technisches Profil' />
      <DataField
        paragraph='Backend & API-Entwicklung'
        body='.NET Core, ASP.NET Core, Node.js, Datenbanken, Container & Orchestrierung' />

      <DataField
        paragraph='Frontend-Technologien'
        body='JavaScript/TypeScript, React, Performance- & Sicherheitsoptimierung' />

      <DataField
        paragraph='Cloud & DevOps'
        body='Microsoft Azure, IaC (Terraform), CI/CD-Pipelines, Docker, Kubernetes' />

      <DataField
        paragraph='System- & Plattformverwaltung'
        body='SharePoint, Windows Server, Linux, Skripting; Deployment & Testing' />

      <DataField
        paragraph='Agile Methoden & Beratung'
        body='SCRUM, technische Beratung & Prozessoptimierung' />



      {/* employments */}
      <Label text='Beruflicher Werdegang' />
      <div>
        <h3 className='strong'>Netze BW GmbH / NETZ-FIBN</h3>
        <span className="job-title">Professional Software Engineer</span> {"Seit 05.2024"}
        <DataField
          paragraph='Entwicklung & Optimierung'
          body='von .NET-Anwendungen sowie Automatisierung von Prozessen zur Effizienzsteigerung' />
        <DataField
          paragraph='Infrastructure as Code'
          body='IaC-Temlates und Azure DevOps CI/CD-Pipelines' />
        <DataField
          paragraph='Cloud-Migration'
          body='Planung, Durchführung und kontinuierliche Verbesserung der Migration der Geoplattform in die Azure Cloud' />
        <DataField
          paragraph='Technische Betreuung'
          body='und Weiterentwicklung von Geoplattform - GIS-Plattform der Netze BW (Esri ArcGIS Enterprise)' />
        <DataField
          paragraph='GIS'
          body='Grundkenntnisse in der Anwendung und Administration von ArcGIS & Integration der VertiGIS-Erweiterungen' />
      </div>

      <div>
        <h3 className='strong'>EnBW Energie Baden-Württemberg AG / C-TIAKK</h3>
        <span className="job-title">Professional Software Engineer</span> {"12.2021 – 04.2024"}
        <DataField
          paragraph='Support und Weiterentwicklung'
          body='interner Applikationen und SharePoint-Apps: Optimierung bestehender Anwendungen mit .NET, React und TypeScript' />
        <DataField
          paragraph='Weiterentwicklung der Azure-Plattform'
          body='Anpassung und Ausbau der Cloud-Infrastruktur' />
        <DataField
          paragraph='Azure DevOps und Administration'
          body='Automatisierung von Entwicklungsprozessen und Verwaltung von Azure-Ressourcen' />
        <DataField
          paragraph='Beratung und technische Begleitung'
          body='Unterstützung von Intranet-Benutzern bei technischen Anliegen' />
      </div>

      <div>
        <h3 className='strong'>INIT GmbH</h3>
        <span className="job-title">Software Engineer</span> {"05.2019 – 11.2021"}
        <DataField
          paragraph='Weiterentwicklung und Optimierung'
          body=' von Ticketing-Systemen - .NET' />
        <DataField
          paragraph='Entwicklung eines DMS'
          body='zur Verwaltung und Archivierung von Kundenverträgen - SharePoint, React/TypeScript, .NET - 1 Man Project' />
        <DataField
          paragraph='Migration von SharePoint 2013'
          body='zu Modern Experience & Neuentwicklung von WebParts - TypeScript/React, .NET - 1 Man Project' />
        <DataField
          paragraph='Code-Optimierung'
          body='zur Leistungssteigerung interner Applikationen (Ladezeiten um 50 % reduziert)' />
      </div>

      <div>
        <h3 className='strong'>Objektkultur Software GmbH</h3>
        <span className="job-title">Softwareentwickler / IT-Berater</span> {"09.2014 – 04.2019"}
        <DataField
          paragraph='Analyse, Beratung und Implementierung'
          body='von Anforderungen (.NET, ASP.NET, Intranet, SharePoint, AngularJS, vue.js)' />
        <DataField
          paragraph='End-to-End-Betreuung'
          body='von Konzeption bis zur Bereitstellung maßgeschneiderter Lösungen' />
      </div>

      <div>
        <h3 className='strong'>Hafen Burgas AG / Bulgarien</h3>
        <span className="job-title">Investments-Gutachter – Abteilung Bauwesen</span> {"08.2007 – 05.2010"}
        <DataField
          paragraph='Überprüfung & Controlling'
          body='von Investitionsprozessen und Angebotsbewertungen' />
        <DataField
          paragraph='Controlling'
        />
      </div>

      <Label text='Ausbildung' />

      {/* Sonstiges */}
      <div>Wirtschaftsinformatiker & Wirtschaftsingenieur</div>
      <h3 className='strong'>Hochschule Karlsruhe</h3>
      <DataField
        paragraph='B.Sc. Wirtschaftsinformatik'
        body='09.2012 – 02.2016' />
      <DataField
        body="Abschlussarbeit: Entwicklung eines Moduls für ein Sportportal (Microsoft SharePoint Online, Azure)" />
      <DataField
        body="Abschlussnote: 1,3" />

      <h3 className='strong'>Wirtschaftsuniversität Varna / Bulgarien</h3>
      <DataField
        paragraph='B.Sc. Wirtschaft des Bauwesens'
        body='09.1998 – 05.2003' />        
      <DataField
        body="Abschlussnote: ~2,0" />

      {/* certifications */}
      <Label text='Zusätzlich' />
      <DataField paragraph='Referenzen auf Anfrage' />
      <DataField paragraph='Zertifizierungen' />
      <div className='blockquote'>
        <div>
          <a href="https://learn.microsoft.com/api/credentials/share/en-us/RosenVasilev-1428/CDA1B6B706F84421?sharingId" target="_blank">Microsoft Certified: DevOps Engineer Expert (AZ-400)</a>
        </div>
        <div>
          <a href="https://learn.microsoft.com/api/credentials/share/en-us/RosenVasilev-1428/B325499CF9B7CD3F?sharingId" target="_blank">Microsoft Certified: Azure Developer Associate (AZ-204)</a>
        </div>
      </div>

      <DataField paragraph='Grundwehrdienst' body='Obermatrose, Kriegsmarine Bulgarien 09.1996 – 01.1998' />
      <DataField paragraph='Freizeit' body='Fahrradtouren, Wandern' />
    </div >
  )
}

export default MyCv;
